<template>
  <v-container fluid>
    <v-layout row wrap v-show="tab === 1">
      <v-flex xs2 md2 >
        <v-btn color="primary" dark text  @click="showFileAddDialog()">新增</v-btn>
      </v-flex>
    </v-layout>
    <v-layout xs12 v-show="tab === 1">
      <v-flex ml-2 md4 xs8>
        <v-text-field v-model="search.keyword" :label="`搜尋檔案名稱或類型`" :placeholder="search.placeholder"
                      @keyup.enter="searchEvent"></v-text-field>
      </v-flex>
      <v-flex md4 xs4>
        <v-btn color="success" @click="searchEvent">搜尋</v-btn>
        <v-btn color="warning" @click="reset">重置</v-btn>
      </v-flex>
    </v-layout>
    <v-layout row wrap >
      <v-tabs v-model="tab">
        <v-tab :key="0">各式表單</v-tab>
        <v-tab :key="1" v-if="isAdmin || isStaff">表單編輯</v-tab>
        <v-tab :key="2" v-if="isAdmin || isStaff">表單類別</v-tab>
      </v-tabs>
    </v-layout>
    <v-layout row wrap mt-2>
      <v-container
        fluid
        grid-list-md v-if="tab === 0">
        <v-layout row wrap v-for="item in categoryList" :key="item.projectId" v-if="selectItem === ''">
          <v-flex xs12 md6 lg4 @click="showList(item.name)">
            <div class="gray-border" >
              <v-card color="white darken-2" class="black-text" >
                <v-card-title primary-title>
                  <div>
                    <div class="headline">{{item.name}}</div>
                  </div>
                </v-card-title>
              </v-card>
            </div>
          </v-flex>
        </v-layout>

        <v-layout row wrap v-if="selectItem !== ''">
          <v-flex xs12 md6 lg4 @click="selectBack()">
            <div class="gray-border" >
              <v-card color="white darken-2" class="black-text" >
                <v-card-title primary-title>
                  <div>
                    <div class="headline"><i class="material-icons">
                      keyboard_backspace
                    </i>返回</div>
                  </div>
                </v-card-title>
              </v-card>
            </div>
          </v-flex>
        </v-layout>

        <v-layout row wrap v-for="file in selectFileList" :key="file.key" v-if="selectItem !== ''">
          <v-flex xs12 md6 lg4 @click="showFileInfo(file.url)">
            <div :class="file.key === 'creditCard_2' ? 'red-border' : 'gray-border'" >
              <v-card color="white darken-2" class="black-text" >
                <v-card-title primary-title>
                  <div>
                    <div class="headline">{{file.fileName}}</div>
                  </div>
                </v-card-title>
              </v-card>
            </div>
          </v-flex>
        </v-layout>
      </v-container>

      <table-view :columnKeys="columnKeys" v-if="tab === 1"
                  :items="items"
                  :loading="loading"
                  :total-items="totalItems"
                  @cellEvent="cellEvent"
                  @changePage="changePage"
                  @handleLoadData="reset">
      </table-view>

      <div v-if="tab === 2">
<!--        <v-layout>-->
<!--          <vue-tags-input-->
<!--            placeholder="表單類別"-->
<!--            v-model="tag"-->
<!--            :tags="tags"-->
<!--            @tags-changed="newTags => tags = newTags"-->
<!--          />-->
<!--        </v-layout>-->

        <v-card>
          <v-card-title>
            <h3>表單類別</h3>
          </v-card-title>
          <v-card-text>
            <v-layout>
              <v-flex md6 xs6>
                <v-btn color="primary" dark text  @click="add()">新增</v-btn>
              </v-flex>
            </v-layout>
            <v-layout v-for="(item, i) of categoryList" :key="item.projectId">
              <v-flex md6 xs6>
                <v-text-field v-model="item.name" label="專案名稱" outline></v-text-field>
              </v-flex >
              <v-flex md2 xs6>
                <v-text-field v-model="item.sort" label="排序" outline></v-text-field>
              </v-flex>
              <v-flex md2 xs6>
                <v-btn color="red" dark text  @click="remove(i)">刪除</v-btn>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions>
            <v-btn color="primary" dark text  :loading="saveLoading" @click="saveSetting()">儲存</v-btn>
          </v-card-actions>
        </v-card>
      </div>
    </v-layout>


    <!--彈出視窗-->
    <alert-view :visible="messageDialog.visible"
                :title="messageDialog.title"
                :content="messageDialog.text"
                :isHtmlContent="true"
                :showCancel="messageDialog.showCancelButton"
                @cancelEvent="messageDialog.cancel"
                @confirmEvent="messageDialog.confirm"></alert-view>

    <file-edit-dialog :visible="fileDialog.visible"
                      :tags="categoryList"
                      :title="fileDialog.title"
                      :item="fileDialog.item"
                      :isNew="fileDialog.isNew"
                      @confirmEvent="fileDialogConfirm"
                      @cancelEvent="fileDialog.cancel"
                      @deleteEvent="deleteInfo"></file-edit-dialog>

    <file-add-dialog :visible="fileAddDialog.visible"
                      :tags="categoryList"
                      :title="fileAddDialog.title"
                      @confirmEvent="fileAddDialogConfirm"
                      @cancelEvent="fileAddDialog.cancel"></file-add-dialog>
  </v-container>
</template>

<script>
import AlertView from '@/components/AlertView';
import TableView from '@/components/TableView';
import { mapActions, mapGetters } from 'vuex';
import FileEditDialog from '@/components/FileEditDialog';
import FileAddDialog from '@/components/FileAddDialog';
import FileModel from '@/models/FIleModel';
import { getFileList, saveFileInfo } from '@/store/actions';
import VueTagsInput from '@johmun/vue-tags-input';
import common from '@/mixins/common';
import { getUUId } from '@/pages/utils/tool';
export default {
  name: 'FileList',
  mixins: [common],
  components: {
    FileAddDialog,
    FileEditDialog,
    AlertView,
    TableView,
    VueTagsInput
  },
  data() {
    return {
      item: {
        projectId: '',
        name: '',
        sort: '',
      },
      tab: 0,
      tag:'',
      tags: [],
      loading: false,
      pageIndex: 1,
      limit: 50,
      totalItems: 0,
      typeStatus:0,
      saveLoading: false,
      search: {
        keyword: "",
        placeholder: "搜尋名稱",
        startDate:  '2021-01-01',
        endDate:  '2121-01-01',
        searchKey:'carName',
      },
      items: [],
      messageDialog: {
        title: "",
        text: "",
        visible: false,
        showCancelButton: false,
        confirm: () => {},
        cancel: () => {},
      },
      fileAddDialog:{
        title: "",
        visible: false,
        isNew:false,
        item: new FileModel(),
        confirm: () => {},
        cancel: () => {},
      },
      fileDialog:{
        title: "",
        visible: false,
        isNew:false,
        item: new FileModel(),
        confirm: () => {},
        cancel: () => {},
      },
      stockListDialog:{
        title:"",
        visible:false,
        type:0,
        items:[],
        confirm: () => {},
        cancel: () => {},
      },
      products: [],
      categoryList: [],
      selectItem: '',
      selectFileList: [],
      category: 'fileType',
    };
  },
  created() {
    this.loadData();
  },
  watch:{
    tag(value){
      console.log(`tag = ${value}`);
    },
    tags(value){
      console.log(`tags = ${JSON.stringify(value)}`);
    },
    tab(value){
      if(value === 0){
        this.limit = 50;
        this.loadData();
      } else if(value === 2){
        this.loadCategoryData();
      } else {
        this.limit = 10;
      }
    }
  },
  computed: {
    ...mapGetters(["getUserInfo", "getAgentList"]),
    columnKeys() {
      const list = [
        { value: "edit", text: "操作", sortable: false, required: false, color: 'primary', isEvent: true },
        { value: "fileName", text: "檔案名稱", sortable: true, required: false },
        {
          value: "category",
          text: "檔案類型",
          sortable: true,
          required: false,
        },
        { value: "url", text: "複製網址", sortable: true, required: false, color: 'primary', isEvent: true },
        { value: "comment", text: "備註", sortable: true, required: false },
        { value: "createdDate", text: "建立時間", sortable: true, required: false }];
      return list
    },
  },
  methods: {
    ...mapActions(['uploadImageData', 'saveFileInfo', 'getFileList', 'updateFileInfo','saveFileSetting', 'deleteFileInfo'
      , 'saveCCHProjects','loadCCHProjects']),
    async loadCategoryData() {
      const res = await this.loadCCHProjects({ category: this.category });
      const result = res.data;

      if (!this.isAdmin && !this.isStaff){
        this.categoryList = [];
        const agent = this.getUserInfo;
        for (let item of result.data){
          const find = agent.categoryList.find(n=>n.name === item.name);
          if (find && find.enable === true){
            this.categoryList.push(item);
          }
        }
      } else {
        this.categoryList = result.data;
      }
      console.log(`items = ${JSON.stringify(result)}`);
    },
    selectBack(){
      this.selectItem = '';
      this.selectFileList = [];
    },
    showList(key){
      this.selectItem = key;
        for (let file of this.items){
          if (file.category === key){
            this.selectFileList.push(file);
          }
        }
    },
    showFileInfo(url){
      window.open(url, '_blank')
    },
    add(){
      const item = {
        projectId: getUUId(),
        name: '',
        sort: this.categoryList.length + 1,
        category: this.category
      }
      this.categoryList.push(item)
    },
    remove(i){
      this.categoryList.splice(i, 1);
    },
    async saveSetting(){
      this.saveLoading = true;
      const res = await this.saveCCHProjects({
        category: this.category,
        items: this.categoryList,
      });
      this.saveLoading = false;
      const result = res.data;
      console.log(`result ${JSON.stringify(result)}`);

      if (result.statusCode === 0 ){
        this.showMessageDialog('提示', result.message, true);
      } else {
        this.showMessageDialog('錯誤', result.message, true);
      }
    },
    searchEvent(){
      this.loadData();
    },
    async loadData(){
      if(this.tab === 0){
        this.limit = 50;
      } else if(this.tab === 1){
      } else {
        this.limit = 10;
      }

      this.loading = true;
      const res = await this.getFileList({
        searchValue: this.search.keyword,
        pageIndex: this.pageIndex,
        limit: this.limit,
      });

      this.loading = false;
      const result = res.data;
      this.items = result.data.list;
      this.totalItems = result.data.header.totalCount;
      this.tags = result.data.tags;
      await this.loadCategoryData();
      // this.categoryList = [];
      // for (let tag of this.tags){
      //   const item = {
      //     key: tag.text,
      //     value: tag.text,
      //   }
      //   this.categoryList.push(item)
      // }
    },
    cellEvent(props) { // cell 按鈕事件 (用Key判斷是點選哪一個
      console.log(`cellEvent ${JSON.stringify(props)}`)
      if (props.key === 'edit'){
        this.showFileEditDialog(false, props.item)
      } else {
        this.copyURL(props.item.url);
      }
    },
    copyURL(url) {
      const input = document.createElement('input');
      input.setAttribute('value', url);
      document.body.appendChild(input);
      input.select();
      document.execCommand('copy');
      document.body.removeChild(input);
      this.showMessageDialog('提示','網址已複製！', true);
    },
    uploadEvent(item, files){
      if (this.fileDialog.isNew === false && (!files || files.length === 0)){
        this.updateFile({
          fileId: item.fileId,
          fileName: item.fileName,
          category: item.category,
          comment: item.comment,
          url: item.url
        });
        return;
      }

      if (this.fileDialog.isNew && files.length === 0){
        this.showMessageDialog('提示', '請選擇要上傳的檔案！', true);
        return;
      }

      const file = files[0];
      const reader = new FileReader();
      reader.onload = (e) => {
        const fileData = e.target.result;
        this.uploadData(file.name, item, fileData);
      }
      reader.readAsDataURL(file);
    },
    uploadData(name, item, fileData){
      this.$store.dispatch('uploadImageData', {
        name: `fileList/${name}`,
        image: fileData,
      }).then((response) => {
        console.log(`upload Data success ${JSON.stringify(response)}`);
        // 處理完成更新資料

        if (this.fileDialog.isNew){
          this.addFile({
            fileName: name,
            category: item.category,
            comment: item.comment,
            url: response
          })
        } else {
          this.updateFile({
            fileId: item.fileId,
            fileName: name,
            category: item.category,
            comment: item.comment,
            url: response
          })
        }

      });
    },
    async addFile(file){
      const res = await this.saveFileInfo({
        fileName: file.fileName,
        category: file.category,
        comment: file.comment,
        url: file.url,
      });
      const result = res.data;
      console.log(`result ${JSON.stringify(result)}`);

      if (result.statusCode === 0 ){
        this.resetInfo();
        this.showMessageDialog('提示', result.message, true);
      } else {
        this.showMessageDialog('錯誤', result.message, true);
      }
    },
    async updateFile(file){
      const res = await this.updateFileInfo({
        fileId: file.fileId,
        fileName: file.fileName,
        category: file.category,
        comment: file.comment,
        url: file.url,
      });
      const result = res.data;
      console.log(`result ${JSON.stringify(result)}`);

      if (result.statusCode === 0 ){
        this.resetInfo();
        this.showMessageDialog('提示', result.message, true);
      } else {
        this.showMessageDialog('錯誤', result.message, true);
      }
    },
    changePage(page) { // 改變頁數 or 每頁筆數
      this.pageIndex = page.page;
      this.limit = page.rowsPerPage;
      this.loadData();
    },
    resetInfo(){
      this.fileDialog.visible = false;
      this.fileDialog.item = new FileModel();
      this.loadData();
    },
    reset(){
      this.search.keyword = '';
      this.loadData();
    },
    showFileAddDialog(){
      this.fileAddDialog.visible = true;
      this.fileAddDialog.cancel = ()=>{
        this.fileAddDialog.visible = false;
      }
    },
    showFileEditDialog(isNew , item){
      this.fileDialog.visible = true;
      this.fileDialog.isNew = isNew;
      if (item){
        this.fileDialog.item = item;
      }
      this.fileDialog.cancel = ()=>{
        this.resetInfo();
        this.fileDialog.visible = false;
      }
    },
    fileAddDialogConfirm(){
      this.fileAddDialog.visible = false;
      this.loadData();
    },
    fileDialogConfirm(data){
      const { item, files } = data;
      this.fileDialog.visible = false;
      this.uploadEvent(item, files);
    },
    async deleteInfo(fileId){
      console.log(`delete = ${fileId}`);
      const res = await this.deleteFileInfo({
        fileId: fileId,
      });
      const result = res.data;
      console.log(`result ${JSON.stringify(result)}`);
      if (result.statusCode === 0 ){
        this.resetInfo();
        this.showMessageDialog('提示', result.message, true);
      } else {
        this.showMessageDialog('錯誤', result.message, true);
      }
    },
    showMessageDialog(title, text, visible, confirmEvent, cancelEvent) {
      this.messageDialog.title = title;
      this.messageDialog.text = text;
      this.messageDialog.visible = visible;
      const self = this;
      this.messageDialog.confirm = () => {
        self.messageDialog.visible = false;
        if (confirmEvent) {
          confirmEvent();
        }
      };

      this.messageDialog.cancel = () => {
        self.messageDialog.visible = false;
        if (cancelEvent) {
          cancelEvent();
        }
      };
    },
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/web/FileList.vue